package one.healthium.onboarding.ui.screens

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import one.healthium.bundle.components.BundleImage
import one.healthium.onboarding.domain.configs.FastingLongTermResultsScreenConfig
import one.healthium.onboarding.ui.UserDataProvider
import one.healthium.onboarding.ui.UserProfileUiModel
import one.healthium.onboarding.ui.bindPlaceholderValues
import one.healthium.ui.components.CtaButton
import one.healthium.ui.compose.components.AppScaffold
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.theme.AppTheme

interface FastingLongTermResultsEventDelegate {
    fun onNextClicked()
}

@Composable
internal fun FastingLongTermResultsScreen(
    eventDelegate: FastingLongTermResultsEventDelegate,
    screenConfig: FastingLongTermResultsScreenConfig,
) {
    UserDataProvider { userState, _ ->
        AppScaffold {
            FastingLongTermResultsScreenContent(
                screenConfig = screenConfig,
                userState = userState,
                onNextClicked = eventDelegate::onNextClicked,
            )
        }
    }
}

@Composable
internal fun FastingLongTermResultsScreenContent(
    modifier: Modifier = Modifier,
    screenConfig: FastingLongTermResultsScreenConfig,
    userState: UserProfileUiModel,
    onNextClicked: () -> Unit,
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .navigationBarsPadding()
            .verticalScroll(rememberScrollState()),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Box(
            modifier = Modifier.fillMaxWidth(),
        ) {
            BundleImage(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(276.dp),
                name = screenConfig.header,
                contentScale = ContentScale.FillBounds,
            )
            AppText(
                modifier = Modifier
                    .fillMaxWidth()
                    .statusBarsPadding()
                    .padding(top = 20.dp)
                    .padding(horizontal = 24.dp),
                text = screenConfig.title?.bindPlaceholderValues(userState),
                style = AppTheme.textStyles.title,
                color = AppTheme.colors.textInverted100,
                textAlign = TextAlign.Center,
            )
        }
        Spacer(Modifier.height(15.dp))
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp),
        ) {
            BundleImage(
                modifier = Modifier.fillMaxWidth(),
                name = screenConfig.chart,
            )
            Text(
                modifier = Modifier.padding(top = 18.dp, start = 12.dp, end = 12.dp),
                text = userState.currentWeight,
                style = AppTheme.textStyles.header,
                color = AppTheme.colors.text100,
            )
        }
        Spacer(Modifier.height(27.dp))
        AppText(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp),
            text = screenConfig.subtitle?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.caption,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.weight(1f))
        Spacer(Modifier.height(16.dp))
        CtaButton(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 38.dp),
            onClick = onNextClicked,
            text = screenConfig.ctaTitle,
        )
        Spacer(Modifier.height(24.dp))
    }
}
